export default __webpack_public_path__ + "static/media/home-desktop-tree.4c5e0db6.png";